
import React, { Component } from 'react';
import services from '../../../services';
import $, { data } from 'jquery'
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import ParcelVirsion from '../../../components/Parcel-Right-panel/ParcelVirsion';
import myDropDownCellOrigemPagamento  from './myDropDownCellOrigemPagamento';
import { insertItem, getItems, updateItem, deleteItem , deleteAll} from "./services2";
import { MyCommandCell } from "./MyCommandCell"
import { NumericCell } from './NumericText';
import { FormatMoney } from './FormatMoney';
import CriacaoReceita from './CriacaoReceita';
import { TextCell } from './TextCell';
import DatePickerGrid from './DatePickerGrid';
import Swal from "sweetalert2";

const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);
var tableData = [];
today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);
var OtherThis;
today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);
const editField = "inEdit"; 
// var entidadeOrd = {...this.state.operation.IDEntidadeOrdenante}
class TableCriacaoPenhora extends Component {
    /* Primeiro passo na acomodação da classe */

    editField = "inEdit";
    state = {
      data: []
    };
    // constructor(props) {
    //   super(props);
    //   this.state = {
    //     operation: {
    //       IDEntidadeDestino: 0,
    //       IDEntidadeOrdenante: 0,
    //     }
    //   }
    // }
    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
          OtherThis = this
          console.log("Detalhes da grid", this.props.columnList);
          //this.defaultState();
  
          (async () => {
              this.setState({
                  data: await getItems(),
                  Columns: this.props.columnList
              }); 
  
              
          })();
    }
    


    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    // componentDidUpdate = (preProp) => {
    //     if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
    //         console.log("update",this.props,preProp)
    //         this.defaultState();
    //     }
    // }


    /*  Para renderizar o conteúdo html da página   */
    CommandCell = props => (
      <MyCommandCell
        {...props}
        edit={this.enterEdit}
        remove={this.remove}
        add={this.add}
        discard={this.discard}
        update={this.update}
        cancel={this.cancel}
        editField={this.editField}
      />
    );

  remove = dataItem => {
    const data = deleteItem(dataItem)
    
    this.setState({
      data
    });
  };
   validateEmail = (email) => {
    if(email != "" && email != undefined){
      if(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email) == false){
        Swal.fire({
          icon: 'error',
          title: 'E-mail inválido',
          text: "O campo e-mail tem de seguir a seguinte formula 'email@email.pt'"
      })
        return false
      }else{
          return true
      }
    }else{
      return true
    }
    
  };
  add = dataItem => {
      $(".k-grid-container").css("border" ,"1px solid #00000014")
      dataItem.inEdit = true;
      // if(dataItem.idPenhoraTipoOrigemValor == "" ){
      //   dataItem.idPenhoraTipoOrigemValor.add({text: $("#id-DropDownCellTipoOrigemValor").text() , value: $("#id-DropDownCellTipoOrigemValor").val()})
      // }else{
      //   dataItem.idPenhoraTipoOrigemValor.text = $("#id-DropDownCellTipoOrigemValor").text();
      //   dataItem.idPenhoraTipoOrigemValor.value = $("#id-DropDownCellTipoOrigemValor").val();
      // }
 
      var emailreturn = this.validateEmail(dataItem.email)
      if(emailreturn == true){
        dataItem.nib = $(".nibFill").val()
        dataItem.ValorPago = $(".volumepagar").val()
        dataItem.idPagamento = null;
        if(dataItem.idPenhoraTipoOrigemValor.text!= "" && dataItem.nib != "" && dataItem.ValorPago != "" ){
            
            const data = insertItem(dataItem);
            this.setState({
                data: data
            });
        
        tableData = data
      }
      
  }
  };
 
  update = dataItem => {
    var emailreturn = this.validateEmail(dataItem.email)
      if(emailreturn == true){
        dataItem.inEdit = false;
   
        const data = updateItem(dataItem);
        
        this.setState({
          data
        });
      }
    
  }; // Local state operations

  discard = dataItem => {
    const data = [...this.state.data];
    data.splice(0, 1);
    this.setState({
      data
    });
  };
  cancel = dataItem => {
    this.setState({data:  this.state.data.map(item => item === dataItem ? { ...item,inEdit: false } : item)}); 
    };
  
    enterEdit = dataItem => {
      this.setState({
        data: this.state.data.map(item =>
          item.ProductID === dataItem.ProductID ? { ...item, inEdit: true } : item
        )
      });
    };
  itemChange = event => {
    const data = this.state.data.map(item => event.dataItem != null ?  item.ProductID === event.dataItem.ProductID ? { ...item,
      [event.field || '']: event.value
  } : item : item);
 
  this.setState({
      data
  });
      
    
  };
  addNew = () => {
      if($('#tabelaNovaAdicionar .k-grid-save-command').length == 0){
          const newDataItem = {
              inEdit: true,
              Discontinued: false,
              valor: "",
              ValorUnitario: "",
              iva: "",
              descricao:""
            };
          
              this.setState({
                  data: [newDataItem, ...this.state.data]
                });
          
      }
  };
  static removeAllrows = () => {
    OtherThis.refreshDS()
  }
  refreshDS = (remove) =>{

    this.setState({
        data: []
    })

   

    deleteAll();
}
  // itemChange = event => {
  //     const data = this.state.data.map(item =>
  //       item.ProductID === event.dataItem.ProductID
  //         ? { ...item, [event.field]: event.value }
  //         : item
  //     );
  
  //     this.setState({ data });
  //   };
  
  //   addNew = () => {
  //     const newDataItem = { inEdit: true, Discontinued: false };
  
  //     this.setState({
  //       data: [newDataItem, ...this.state.data]
  //     });
  //   };

    render() {
        return (
            
        <div className="custom-k-grid table-section">
                <div className="table-responsive" id='tabelaNovaAdicionar'>     
                <Grid
                    style={{ height: "420px" }}
                    data={this.state.data}
                    onItemChange={this.itemChange}
                    editField={this.editField}
                >
                  {/* <GridToolbar>
                    <button title="Add new" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary botaoAdicionarNovoEnable" id='botaoAdicionarNovo' onClick={this.addNew}>
                       + Adicionar Nova Linha
                    </button>
                  </GridToolbar> */}
                  <Column field="ProductID" title="Linha" width="60px" editable={false} />
                  <Column field="idPenhoraTipoOrigemValor" title="Origem Valor" width="100px" cell={myDropDownCellOrigemPagamento} />
                  <Column field="nib" title="NIB"  width="190px" cell={NumericCell}/>
                  <Column field="ValorPago" title="Valor Pago (€)"  width="130px"cell={FormatMoney}/>
                  <Column field="email" title="Email"  width="130px"/>
                  <Column field="DataCriado" title="Data Criado"  width="130px" editable={false} />
                  <Column field="criadoPor" title="Utilizador"  width="200px" editable={false}/>
                  {/* <Column field="dataMovimento" title="Data Movimento"  width="130px" editable={false}/> */}
                  <Column field="dataMovimento" title="Data Movimento" width="130px" cell={DatePickerGrid}/>
                  <Column cell={this.CommandCell} width="90px" />
                </Grid>
        
                </div>
        </div>
    )}
}

export default TableCriacaoPenhora;